import axios from 'axios';
import {getItem} from '../utils/storage';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';

/**
 * returns response or error of api call
 * @param  {object} response [response of api call]
 * @return {object}          [response or error]
 */
function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function setAddressBook(data){
  return {
      type: 'SET_ADDRESS_BOOK',
      payload: data
  };
}

/**
 * gets data of addressbook (contacts)
 * @param  {boolean} save if we want to save data in store
 * @return {object}
 */
export const getAddressBook = (perPage = 100, onDataFetched) => dispatch => {
  let currentPage = 1;
  let newItems = [];
  let currentItems = [];
  let addressBookItems = [];

  const getAddressBookPage = page => {
    return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Client", {
        action: "getAddressBook",
        params: {
          agent_id: localStorage.getItem("agent_id"),
          num_contacts: perPage,
          offset: (page - 1) * perPage
        }
      })
      .then(response => {
        try {
          currentItems = response.data.response.items;
          newItems.push(...currentItems);
          const offset = newItems.length - currentItems.length;
          const items = newItems.slice(offset, newItems.length);
          dispatch(setAddressBook(addressBookItems));
          addressBookItems.push(...items);

          if (currentItems.length === perPage && currentItems.length > 0) {
            currentPage += 1;
            onDataFetched(items); // Call the callback function with the fetched items
            return getAddressBookPage(currentPage);
          } else {
            //console.log("All address book items retrieved!");
            onDataFetched(addressBookItems); // Call the callback function with all the fetched items
            return { result: true, response: { items: addressBookItems } };
          }
        } catch (e) {
          console.log(e);
          return { result: false, error: e };
        }
      })
      .catch(error => {
        return handleResponse(error.response);
      });
  };

  getAddressBookPage(currentPage);
};






// WEBPACK FOOTER //
// ./src/actions/addressBook.js